import { IconsService } from '$services/icons/icons.service';
import { PostsService } from '$services/posts/posts.service';
import { PostWithDatasDTO, HorseSex } from '$types';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { EuroPipe } from '$pipes/euro.pipe';
import { User } from '$types';
import { AuthService } from '$services/auth/auth.service';

@Component({
  selector: 'app-display-post-page',
  templateUrl: './display-post-page.component.html',
  styleUrls: ['./display-post-page.component.css'],
})
export class DisplayPostPageComponent implements OnInit {
  user: User | null;
  post?: PostWithDatasDTO
  hiddenPhoneNumber: string = '?';
  images: any[] = [];
  imagePreview: boolean = false;
  responsiveOptions: any[] = [
          {
              breakpoint: '1024px',
              numVisible: 5
          },
          {
              breakpoint: '768px',
              numVisible: 3
          },
          {
              breakpoint: '560px',
              numVisible: 1
          }
      ];

  constructor(private readonly route: ActivatedRoute,
    private readonly postService: PostsService,
    private readonly authService: AuthService,
    private readonly icons: IconsService)
    {
      this.user = this.authService.user;
    }

  ngOnInit(): void {
    this.icons.registerIcon(['horse-placeholder'])
    const id = this.route.snapshot.paramMap.get('id')!
    this.recupererInfosCheval(id)
  }

  recupererInfosCheval(id: string) {
    this.postService
      .findById(id)
      .subscribe((post) => {
        this.post = post
      });
  }

  get language():string {
    return localStorage.getItem('language') || 'fr'
  }

  showPhoneNumber(): void {

    if (this.post?.contact?.mobilePhoneNumber) {
      this.hiddenPhoneNumber = this.post?.contact?.mobilePhoneNumber
    }
    else if (this.post?.contact?.landlinePhoneNumber) {
      this.hiddenPhoneNumber = this.post?.contact?.landlinePhoneNumber
    }
    else {
      this.hiddenPhoneNumber = 'pas de téléphone'
    }
  }
  getComment():string {
    switch (this.language) {
      case 'fr':
        return this.post?.commentsFr??''

      case 'en':
        return this.post?.commentsEn??''
      default:
        throw new Error('language yet not implemented.');
    }
  }

  isMale(): boolean {
      if(this.post?.horse?.sex){
        return this.post?.horse?.sex.toUpperCase() == HorseSex.MALE.toUpperCase()
      }
      return false;
    }

  isFemale(): boolean {
          if(this.post?.horse?.sex){
            return this.post?.horse?.sex.toUpperCase() == HorseSex.FEMALE.toUpperCase()
          }
          return false;
        }

  isHongre(): boolean {
        if(this.post?.horse?.sex){
          return this.post?.horse?.sex.toUpperCase() == HorseSex.HONGRE.toUpperCase()
        }
        return false;
      }

  price(): number {
    if(this.post?.sellPrice){
      return this.post?.sellPrice
    }
    return 0;
  }

  goBack() {
    history.back();
  }


  getHorseRegistration(){
    if (this.post!.horseRegistration){
      this.downloadFile(this.post!.horseRegistration, "Immatriculation")
    }
  }

  getCertificateOfSale(){
    if (this.post!.certificateOfSale){
      this.downloadFile(this.post!.certificateOfSale, "Certificat_de_vente")
    }
  }

  getCertificationOfThePerson(){
    if (this.post!.certificationOfThePerson){
      this.downloadFile(this.post!.certificationOfThePerson, "Certificat_de_personne")
    }
  }

  getExtractKbis(){
    if (this.post!.extractKbis){
      this.downloadFile(this.post!.extractKbis, "Extrait_kbis")
    }
  }


  detectFileType(file: string) {
    if (file.startsWith('data:image/jpeg')) {
      return 'image/jpeg';
    } else if (file.startsWith('data:image/png')) {
      return 'image/png';
    } else if (file.startsWith('data:application/pdf')) {
      return 'application/pdf';
    } else {
      console.error('Format de fichier non pris en charge.');
      return;
    }
  }


  downloadFile(file: string, filename: string) {
    const byteCharacters = atob(file.split(';base64,')[1]);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);

    const blob = new Blob([byteArray], { type: this.detectFileType(file) });

    const a = document.createElement('a');
    a.href = URL.createObjectURL(blob);
    a.download = filename + "_" + this.post!.horse!.name + "." + this.getFileExtension(file)
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  }

  getFileExtension(file: string): string {
    if (this.detectFileType(file) === 'image/jpeg') {
      return 'jpg';
    } else if (this.detectFileType(file) === 'image/png') {
      return 'png';
    } else if (this.detectFileType(file) === 'application/pdf') {
      return 'pdf';
    }
    return '';
  }

}
